// extracted by mini-css-extract-plugin
module.exports = {"inputsContainer":"inputs-container_inputsContainer__yYYEs"};